import React, { useState } from "react";
import "./UpdateCorporateStyles.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";

const UpdateCorporateComponent = (props) => {
  const [domainInput, setDomainInput] = useState("");

  const handleBusinessNameChange = (e) => {
    if (e.target.value.length <= 50) {
      const event = {
        target: {
          name: "name",
          value: e.target.value
        }
      };
      props.handleChangeCorporate(event);
    }
  };

  const handleDomainInputChange = (e) => {
    if (e.target.value.length <= 50) {
      setDomainInput(e.target.value);
    }
  };

  const addDomain = () => {
    if (domainInput.trim()) {
      const event = {
        target: {
          name: "domain",
          value: domainInput.trim()
        }
      };
      props.handleChangeCorporate(event);
      setDomainInput("");
    }
  };

  const removeDomain = (index) => {
    if (props.handleRemoveDomain) {
      props.handleRemoveDomain(index);
    } else {
      const newDomains = [...props.createCorporateData.corporateDomains];
      newDomains.splice(index, 1);
      props.setCreateCorporateData({
        ...props.createCorporateData,
        corporateDomains: newDomains
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && domainInput.trim()) {
      e.preventDefault();
      addDomain();
    }
  };

  const clearBusinessName = () => {
    const event = {
      target: {
        name: "name",
        value: ""
      }
    };
    props.handleChangeCorporate(event);
  };

  const clearDomainInput = () => {
    setDomainInput("");
  };

  const isLoading = props.loading;

  // Get domains array from corporateDomains or domains
  const domains = props.createCorporateData.corporateDomains || props.createCorporateData.domains || [];

  return (
    <div className="corporate-create-container">
      <div className="corporate-create-card">
        <Box className="corporate-form-box">
          <h2 className="corporate-form-title">
            {props.isUpdateMode ? "Update Corporate Details" : "Corporate Details"}
          </h2>
          
          <p className="corporate-form-subtitle">
            {props.isUpdateMode 
              ? "Update the details for the corporate entity." 
              : "Fill in the details for the new corporate entity. You can add more for bulk creations."}
          </p>
          
          <div className="corporate-form-fields">
            <div className="corporate-field-group">
              <label className="corporate-field-label">
                Business Name  <span style={{color:"red"}}> *</span>
                <span className="character-count">
                  {props.createCorporateData.name?.length || 0}/50
                </span>
              </label>
              <div className="input-with-clear">
                <TextField
                  className="corporate-text-field"
                  fullWidth
                  placeholder="Enter business name"
                  value={props.createCorporateData.name || ""}
                  onChange={handleBusinessNameChange}
                  variant="outlined"
                  size="medium"
                  disabled={isLoading}
                  inputProps={{
                    maxLength: 50
                  }}
                />
                {props.createCorporateData.name && !isLoading && (
                  <IconButton
                    className="clear-input-btn"
                    onClick={clearBusinessName}
                    size="small"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </div>

            <div className="corporate-field-group">
              <label className="corporate-field-label">
                Business Domains <span style={{color:"red"}}> *</span>
                <span className="character-count">
                  {domainInput.length}/50
                </span>
              </label>
              
              <div className="domain-input-container">
                <div className="input-with-clear">
                  <TextField
                    className="corporate-text-field domain-input"
                    fullWidth
                    placeholder="example.com"
                    value={domainInput}
                    onChange={handleDomainInputChange}
                    onKeyDown={handleKeyDown}
                    variant="outlined"
                    size="medium"
                    disabled={isLoading}
                    inputProps={{
                      maxLength: 50
                    }}
                  />
                  {domainInput && !isLoading && (
                    <IconButton
                      className="clear-input-btn"
                      onClick={clearDomainInput}
                      size="small"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </div>
                <Button
                  className="add-domain-btn"
                  startIcon={<AddIcon />}
                  onClick={addDomain}
                  variant="outlined"
                  size="medium"
                  disabled={!domainInput.trim() || isLoading}
                >
                  Add
                </Button>
              </div>
              
              <div className="domain-chips-container">
                {domains && domains.map((domainItem, index) => {
                  const domainName = typeof domainItem === 'string' ? domainItem : domainItem.domain;
                  return domainName && (
                    <Chip
                      key={index}
                      label={domainName}
                      onDelete={isLoading ? undefined : () => removeDomain(index)}
                      deleteIcon={<CloseIcon />}
                      className="domain-chip"
                      variant="outlined"
                    />
                  );
                })}
              </div>
            </div>
          </div>

          {isLoading && (
            <div className="corporate-loading-indicator">
              <CircularProgress size={24} />
              <span>{props.isUpdateMode ? "Loading corporate details..." : "Creating corporate..."}</span>
            </div>
          )}
        </Box>
      </div>
    </div>
  );
};

export default UpdateCorporateComponent;